import React, { createContext, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import Arabic from "../lang/ar.json";
import English from "../lang/en.json";
import French from "../lang/fr.json";
export const LanguageContext = createContext();

const preferredLanguage = sessionStorage.getItem("preferredLanguage");

const userLocale = preferredLanguage || "en";

let lang;
if (userLocale === "en") {
  lang = English;
} else if (userLocale === "ar") {
  lang = Arabic;
} else if (userLocale === "fr") {
  lang = French;
}

export const LanguageContextWrapper = (props) => {
  const [locale, setLocale] = useState(userLocale);
  const [messages, setMessages] = useState(lang);

  useEffect(() => {
    if (locale === "ar") {
      document.dir = "rtl";
    } else {
      document.dir = "ltr";
    }
  }, [locale]);

  function selectLanguage(e) {
    const newLocale = e?.target?.value || e;
    setLocale(newLocale);
    if (newLocale === "en") {
      sessionStorage.setItem("preferredLanguage", newLocale);
      setMessages(English);
      document.dir = "ltr";
    } else if (newLocale === "ar") {
      sessionStorage.setItem("preferredLanguage", newLocale);
      setMessages(Arabic);
      document.dir = "rtl";
    } else if (newLocale === "fr") {
      sessionStorage.setItem("preferredLanguage", newLocale);
      setMessages(French);
      document.dir = "ltr";
    }
    console.log(newLocale);
  }

  return (
    <LanguageContext.Provider value={{ locale, selectLanguage }}>
      <IntlProvider messages={messages} locale={locale} defaultLocale="en">
        {props.children}
      </IntlProvider>
    </LanguageContext.Provider>
  );
};
